import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { CircularProgress, Typography } from "@mui/material";

const width = 200;
const height = 200;
const border = 10;
export default function LoadingScreen() {
  return (
    <Box
      width="100%"
      height="100vh"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      {/* <Typography  sx={{ zIndex: 1, color: "#fff", fontSize: 40, fontWeight: 200 }}>
        m-Path
      </Typography>
      <Box
        sx={{
          backgroundColor: "primary.main",
          color: "primary.main",
          position: "absolute",
          width: width,
          height: height,
          borderRadius: "50%",
          margin: "auto",
          "@keyframes ripple": {
            "0%": {
              transform: "scale(.8)",
              opacity: 1,
            },
            "100%": {
              transform: "scale(1.8)",
              opacity: 0,
            },
          },
          "&::after": {
            position: "absolute",
            top: 0,
            left: 0,
            width: width - 2 * border,
            height: width - 2 * border,
            borderRadius: "50%",
            animation: "ripple 1.2s infinite ease-in-out",
            border: `${border}px solid currentColor`,
            content: '""',
          },
        }}
      /> */}
      <CircularProgress />
    </Box>
  );
}
